'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$16() {
  this.bfW = null;
  this.bfU = null;
  this.bfV = false;
  this.bfS = null;
  this.bfT = false;
  this.bfX = false;
  this.bfY = false;
  this.bfW = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_PrestoRouter$$anon$16 as $c_Lpresto_PrestoRouter$$anon$16 };
$p = $c_Lpresto_PrestoRouter$$anon$16.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$16;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$16() {
}
export { $h_Lpresto_PrestoRouter$$anon$16 as $h_Lpresto_PrestoRouter$$anon$16 };
$h_Lpresto_PrestoRouter$$anon$16.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.af = (function() {
  return this.bfW;
});
$p.t = (function() {
  if ((!this.bfV)) {
    this.bfU = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bfV = true;
  }
  return this.bfU;
});
$p.ag = (function() {
  if ((!this.bfT)) {
    this.bfS = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bfT = true;
  }
  return this.bfS;
});
$p.v = (function() {
  if ((!this.bfY)) {
    this.bfX = false;
    this.bfY = true;
  }
  return this.bfX;
});
$p.ae = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_PrestoRouter$$anon$16 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$16, "presto.PrestoRouter$$anon$16", ({
  NO: 1,
  a: 1,
  l: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$16 as $d_Lpresto_PrestoRouter$$anon$16 };
//# sourceMappingURL=presto.-Presto-Router$$anon$16.js.map
